import { Component } from '@angular/core';

@Component({
  selector: 'app-qa',
  imports: [],
  templateUrl: './qa.html',
  styleUrl: './qa.scss'
})
export class QA {

  navigateToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

}
